import { getMetaConsent } from "./metaConsent";
import { discardPendingMetaEvents, sendMetaEvent } from "./metaPixelTransport";

// An allowlist also prevents unknown/private paths from leaking into analytics.
const publicPaths = new Set(["/", "/services", "/projects", "/contact"]);
const canonicalPath = (path) => path.toLowerCase().replace(/\/+$/, "") || "/";
export const isPublicMetaPath = (path) => publicPaths.has(canonicalPath(path));
let currentPath = null;
let pageViewSent = false;
let navigation = 0;
const completedQuotes = new Set();

export function trackMetaPageView(pathname) {
  const path = canonicalPath(pathname);
  if (currentPath !== path) {
    currentPath = path;
    pageViewSent = false;
    navigation += 1;
  }
  if (!isPublicMetaPath(path)) {
    // Do not flush delayed public events with an admin/login URL as SDK context.
    discardPendingMetaEvents();
    return false;
  }
  if (pageViewSent || getMetaConsent() !== "accepted") return false;
  // Module-level state survives StrictMode effects and component remounts.
  const eventNavigation = navigation;
  pageViewSent = sendMetaEvent("PageView", () => {
    if (navigation === eventNavigation) pageViewSent = false;
  });
  return pageViewSent;
}

export function trackQuoteLead(quoteId) {
  if (typeof quoteId !== "string" || !quoteId.trim() || completedQuotes.has(quoteId)) return false;
  // The opaque response ID is for local deduplication only. Never send it to Meta.
  // Remember even untracked successes: later acceptance must not replay them.
  completedQuotes.add(quoteId);
  if (!isPublicMetaPath(window.location.pathname)) return false;
  return sendMetaEvent("Lead");
}